import { generatePath } from "react-router";

import { PageMeta } from "@/lib/react-helmet-async";

import { PATHS } from "@/routes/paths";

import { CampaignEditContainer } from "@/components/features/marketing/campaign/edit/default/ui/existing";

import { useGetCampaignEditPageParams } from "./_hooks/use-get-campaign-edit-page-params";

export const MarketingCampaignEditPage = () => {
	const { hotelID, campaignID } = useGetCampaignEditPageParams();

	return (
		<PageMeta
			title="キャンペーンの編集"
			url={generatePath(PATHS.HOTEL.MARKETING.CAMPAIGN.EDIT, { hotelID, campaignID })}
		>
			<CampaignEditContainer hotelID={hotelID} campaignID={campaignID} />
		</PageMeta>
	);
};

MarketingCampaignEditPage.displayName = "MarketingCampaignEditPage";
